export default "__VITE_ASSET__Dj64FuwW__"